import { gql } from "@apollo/client";

export const CREATE_QUESTIONNAIRE_MODULE = gql`
  mutation CreateQuestionnaireModule($eventId: ID!) {
    createQuestionnaireModule(eventId: $eventId) {
      id
      moduleStatus
      questions {
        id
        title
        description
        required
        type
        options
        order
      }
    }
  }
`;

export const DELETE_QUESTIONNAIRE_MODULE = gql`
  mutation DeleteQuestionnaireModule($eventId: ID!) {
    deleteQuestionnaireModule(eventId: $eventId)
  }
`;

export const CREATE_QUESTIONNAIRE_QUESTION = gql`
  mutation CreateQuestionnaireQuestion(
    $questionnaireId: ID!
    $title: String!
    $description: String
    $required: Boolean!
    $type: QuestionType!
    $options: [String!]
  ) {
    createQuestionnaireQuestion(
      questionnaireId: $questionnaireId
      title: $title
      description: $description
      required: $required
      type: $type
      options: $options
    ) {
      id
      title
      description
      required
      type
      options
      order
    }
  }
`;

export const UPDATE_QUESTIONNAIRE_QUESTION = gql`
  mutation UpdateQuestionnaireQuestion(
    $questionId: ID!
    $title: String!
    $description: String
    $required: Boolean!
    $type: QuestionType!
    $options: [String!]
  ) {
    updateQuestionnaireQuestion(
      questionId: $questionId
      title: $title
      description: $description
      required: $required
      type: $type
      options: $options
    ) {
      id
      title
      description
      required
      type
      options
      order
    }
  }
`;

export const DELETE_QUESTIONNAIRE_QUESTION = gql`
  mutation DeleteQuestionnaireQuestion($questionId: ID!) {
    deleteQuestionnaireQuestion(questionId: $questionId)
  }
`;

export const REORDER_QUESTIONNAIRE_QUESTIONS = gql`
  mutation ReorderQuestionnaireQuestions($questionnaireId: ID!, $orderedQuestionIds: [ID!]!) {
    reorderQuestionnaireQuestions(questionnaireId: $questionnaireId, orderedQuestionIds: $orderedQuestionIds) {
      id
      order
    }
  }
`;

export const ANSWER_QUESTIONNAIRE = gql`
  mutation AnswerQuestionnaire($cartItemId: ID!, $answers: [QuestionnaireAnswerInput!]!) {
    answerQuestionnaire(cartItemId: $cartItemId, answers: $answers)
  }
`;